const TEMPLATE_CLASSIFICATION = 'template';
export default project => project.classification === TEMPLATE_CLASSIFICATION;
//# sourceMappingURL=isProjectTemplate.js.map